<template>
  <div style="display: inline-block">
    <b-button
      size="xs"
      style="font-size: 0.675rem"
      @click="SendMailAlert"
      variant="outline-primary"
      class="ml-2"
      >Send Email</b-button
    >
    <!-- Additional Add User Client Modal Start -->
    <b-modal
      id="Agent_Coloder-modal"
      ref="Agent_Coloder-modal"
      title="Send Email"
      size="xl"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <b-row>
        <b-col md="9">
          <label>To<span class="error"></span></label>
          <b-form-input
            :formatter="capitalizeAll"
            id="to"
            name="to"
            v-model="agentForm.to"
          ></b-form-input>
        </b-col>
        <b-col md="3">
          <b-button
            @click="showEmailIDDet(agentForm, agentForm.mailTypeVal)"
            variant="info"
            size="xs"
            style="font-size: 0.675rem"
            class="mt-1"
            >{{
              agentForm.mailTypeVal == "previouscc"
                ? "CC"
                : (agentForm.mailTypeVal == "previousbcc"
                    ? "BCC"
                    : agentForm.mailTypeVal == "previousto"
                    ? "To"
                    : "To") + " Email IDs"
            }}</b-button
          >
          <model-list-select
            :list="TypeOfMailList"
            v-model="agentForm.mailTypeVal"
            option-value="mailTypeVal"
            option-text="mailTypeTxt"
            placeholder="Select Type"
            @input="getEmailType(agentForm.mailTypeVal)"
          ></model-list-select>
        </b-col>
        <b-col md="12">
          <label>CC<span class="error"></span></label>
          <b-form-input
            :formatter="capitalizeAll"
            id="cc"
            name="cc"
            v-model="agentForm.cc"
          ></b-form-input>
        </b-col>
        <b-col md="12">
          <label>
            BCC
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            id="bcc"
            name="bcc"
            v-model="agentForm.bcc"
          ></b-form-input>
        </b-col>
        <b-col md="12">
          <label>
            Subject
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            id="subject"
            name="subject"
            v-model="agentForm.subject"
          ></b-form-input>

          <span class="error" v-if="!agentForm.subject">{{
            errorMailDetails.subject
          }}</span>
        </b-col>
        <b-col md="12">
          <label>
            Body
            <span class="error">*</span>
            <quill-editor
              style="
                width: 100% !important;
                height: 300px !important;
                background: #fff;
                display: inline-block;
              "
              v-model="agentForm.mailbody"
            ></quill-editor>
          </label>
          <span class="error" v-if="!agentForm.mailbody">{{
            errorMailDetails.mailbody
          }}</span>
        </b-col>
        <b-col md="12">
          <label>
            Doc
            <span class="error"></span>
          </label>
          <Single-Upload
            :disabled="agentColoder_inputFlag"
            :documentName="'agentForm_mail_doc_'"
            :otherDocName="'agentForm_mail_doc_'"
            :folderName="'Console_Booking_Doc'"
            :accept="'*'"
            :assign_no="`Console_Booking_Doc`"
            :multiple="true"
            v-model="agentForm.doc"
            :state="Boolean(agentForm.doc)"
            :fileAllModuleId="agentForm.subject"
          ></Single-Upload>
          <span
            v-if="
              agentForm.doc != '' && agentForm.doc != undefined && agentForm.doc != null
            "
          >
            <b v-if="agentForm.doc.split(',').length > 0">
              <span
                v-for="(item_doc, index_doc) in sanitizedArray(agentForm.doc.split(','))"
                :key="index_doc"
              >
                <a
                  v-if="item_doc != ''"
                  href="javascript:void(0)"
                  @click="ViewDocFile(item_doc)"
                  >View Document - {{ index_doc + 1 }}</a
                >
                <br />
              </span>
            </b>
            <b v-else>
              <a
                v-if="
                  agentForm.doc != '' &&
                  agentForm.doc != undefined &&
                  agentForm.doc != null
                "
                href="javascript:void(0)"
                @click="ViewDocFile(agentForm.doc)"
                >View Document</a
              >
            </b>
          </span>
        </b-col>
      </b-row>
      <b-button
        :disabled="agentForm.sendMail"
        @click="SendMail"
        variant="success"
        class="pull-right ml-2 mt-2"
        >Send
        <md-spinner v-if="agentForm.sendMail" md-indeterminate id="loader"></md-spinner
      ></b-button>
      <b-button @click="HideModalAgent" variant="danger" class="pull-right mt-2">
        Close</b-button
      >
    </b-modal>

    <b-modal
      id="EmailIDS-modal"
      ref="EmailIDS-modal"
      :title="
        agentForm.mailTypeVal == 'previouscc'
          ? 'CC'
          : (agentForm.mailTypeVal == 'previousbcc'
              ? 'BCC'
              : agentForm.mailTypeVal == 'previousto'
              ? 'To'
              : 'To') + ' Email IDs'
      "
      size="xl"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <b-row>
        <b-col md="12">
          <label>{{
            agentForm.mailTypeVal == "previouscc"
              ? "CC"
              : agentForm.mailTypeVal == "previousbcc"
              ? "BCC"
              : agentForm.mailTypeVal == "previousto"
              ? "To"
              : "To"
          }}</label>
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="agentForm[agentForm.mailTypeVal]"
            required
          ></b-form-textarea>
          <b-button
            @click="HideModalEmailIDS"
            size="xs"
            style="font-size: 0.675rem"
            variant="danger"
            class="pull-right mt-2"
          >
            Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- Additional Add User Client Modal End -->
    <md-dialog-confirm
      :md-title="alert.title"
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      @close="ShowModalAgentColoder"
      ref="sendMailPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";
import { ModelListSelect } from "vue-search-select";
import SingleUpload from "./singleUpload.vue";
import ClientUserService from "../../services/ClientUserService";
export default {
  props: ["AgentId", "AllEmailId", "type"],
  components: {
    ModelListSelect,
    SingleUpload,
    ClientUserService,
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.agentForm.doc = file;
    });
  },
  data() {
    return {
      docURL: URL_BASE_DOC,
      agentColoder_inputFlag: false,
      isCheckAll: false,
      All_Agentds: this.AgentId,
      All_EmailId: this.AllEmailId,
      selectedAllAgentds: "",
      selectedEmailId: "",
      TypeOfMailList: [
        {
          mailTypeVal: "previouscc",
          mailTypeTxt: "CC",
        },
        {
          mailTypeVal: "previousbcc",
          mailTypeTxt: "BCC",
        },
        {
          mailTypeVal: "previousto",
          mailTypeTxt: "TO",
        },
      ],
      agentForm: {
        sendMail: false,
        mail_id: "",
        cc: "",
        bcc: "",
        to: "",
        previousto: "",
        previouscc: "",
        previousbcc: "",
        mailTypeVal: "previousto",
        subject: "",
        mailbody: "",
        doc: "",
      },
      validate: false,
      errorMailDetails: {
        subject: "",
        mailbody: "",
      },
      arrayErrorMailDetails: [
        {
          subject: "Please Enter Subject",
          mailbody: "Please Select Mail Content",
        },
      ],
      alert: {
        content: "",
        ok: "ok",
      },
    };
  },
  methods: {
    showEmailIDDet(IDS, type) {
      console.log(IDS);
      this.agentForm.mailTypeVal = type;
      this.agentForm[type] = this.AllEmailId;
      console.log(type);
      console.log(this.agentForm);
      this.$refs["EmailIDS-modal"].show();
    },
    HideModalEmailIDS() {
      this.$refs["EmailIDS-modal"].hide();
    },
    getEmailType(mailTypeVal) {
      console.log(mailTypeVal);
      if (mailTypeVal == "previousto") {
        this.agentForm.previousto = this.AllEmailId.toString();
        this.agentForm.previouscc = "";
        this.agentForm.previousbcc = "";
      } else if (mailTypeVal == "previouscc") {
        this.agentForm.previousto = "";
        this.agentForm.previouscc = this.AllEmailId.toString();
        this.agentForm.previousbcc = "";
      } else if (mailTypeVal == "previousbcc") {
        this.agentForm.previousto = "";
        this.agentForm.previouscc = "";
        this.agentForm.previousbcc = this.AllEmailId.toString();
      }
    },
    clearMailData() {
      this.agentColoder_inputFlag = false;
      this.isCheckAll = false;
      this.All_Agentds = [];
      this.All_EmailId = [];
      this.selectedAllAgentds = "";
      this.selectedEmailId = "";
      this.agentForm = {
        sendMail: false,
        mail_id: "",
        cc: "",
        bcc: "",
        to: "",
        previousto: "",
        previouscc: "",
        previousbcc: "",
        mailTypeVal: "previousto",
        subject: "",
        mailbody: "",
        doc: "",
      };
      this.HideModalAgent();
      this.agentForm.doc = [];
    },

    ShowModalAgentColoder(dataType) {
      if (dataType == "ok") {
        this.getEmailType(this.agentForm.mailTypeVal);
        if (this.All_Agentds.length > 0) {
          this.$refs["Agent_Coloder-modal"].show();
          $(".ql-toolbar").css("display", "block");
          $(".quill-editor").css("overflow", "visible");
        } else {
          this.alert.content = "Please Select Atlease 1 User";
          this.$refs["addPop"].open();
        }
      }
    },
    HideModalAgent() {
      this.$refs["Agent_Coloder-modal"].hide();
    },
    validateMailDetail() {
      let validate_new = true;
      Object.keys(this.errorMailDetails).map((x, index) => {
        if (
          this.agentForm[x] == "" ||
          this.agentForm[x] == 0 ||
          this.agentForm[x] == undefined ||
          this.agentForm[x] == null ||
          this.agentForm[x] == "undefined" ||
          this.agentForm[x] == "null"
        ) {
          // alert("Pri");
          this.errorMailDetails[x] = this.arrayErrorMailDetails[0][x];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    SendMailAlert() {
      this.alert.content =
        "You are Selected " +
        this.AgentId.length +
        " " +
        this.type +
        " Are you want to Proceed";
      this.$refs["sendMailPop"].open();
    },
    SendMail() {
      if (this.All_Agentds.length > 0) {
        this.agentForm.AllAgentds = this.All_Agentds;
        // this.agentForm.previousto = this.All_EmailId;
        this.agentForm.TypeofAdd = "Send EMail";
        this.agentForm.TypeofSender = this.type;
        let payload = {
          itemCode: "sendAgentEmail",
          agentForm: this.agentForm,
        };

        payload = JSON.stringify(payload);
        console.log("payload=>", payload);
        this.validateMailDetail();
        // return false;
        if (this.validate != false) {
          this.agentForm.sendMail = true;
          ClientUserService.getAllOverseaLock(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              console.log("data=>", data);
              if (status == 200) {
                if (data.is_email_send == true && data.mail_id > 0) {
                  this.clearMailData();
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                }
                eventBus.$emit("sendMailID", data);
                this.agentForm.sendMail = false;
              }
              this.isLoading = false;
            })
            .catch((error) => {
              console.log("Catch on Proforma Error: ", error);
            });
        }
      }
    },
    sanitizedArray(validity_doc) {
      console.log("validity_doc=>", validity_doc);
      return validity_doc.map((item) => item.replace(/\n/g, ""));
    },
    ViewDocFile(validity_doc) {
      window.open(
        `${this.docURL}/ASSIGNMENT_UPLOADS/Console_Booking_Doc` + "/" + validity_doc
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// sendEmail.vue?4f76d519